import React, { useState, useEffect } from 'react';
import firebase from 'firebase'

const useFetchFiltro = (nodo) => {
    const [data, setData]             = useState([]);
    const [filtro, setFiltro]         = useState('');
    const [nodoFiltro, setNodoFiltro] = useState('');
    const [isLoading, setIsLoading]   = useState(false);
    const [isError, setIsError]       = useState(false);

    const buscar = async (value)=>{
        const snap     = await firebase.database().ref().child(nodo).orderByChild(nodoFiltro).equalTo(value).once('value')
        const preData  = snap.val();
        const preArray = [];
        for (const key in preData) {
            preData[key].key = key;
            preArray.push(preData[key]);
        }
        
        return preArray;
    }

    useEffect(() => {
        (async () => {
            setIsError(false);
            setIsLoading(true);
            try{
                if (filtro && nodoFiltro) {
                    let preData = [];
                    if(Array.isArray(filtro)){
                        for (const item of filtro) {
                            const resultados = await buscar(item);
                            preData  = [...preData, ...resultados];
                        }

                    }else{
                        preData  = await buscar(filtro)
                    }
                    
                    setData(preData);
                }
            }catch(error){
                setIsError(true);
            }
            setIsLoading(false);
        })();
    }, [filtro, nodoFiltro]);

    return {data, setFiltro, setNodoFiltro, isLoading, isError};
}

export default useFetchFiltro;


// WEBPACK FOOTER //
// ./src/Components/Hooks/useFetchFiltro.js